/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { oneOfType, string, object, array } from 'prop-types';

const renderValue = (value, list) => {
  const tags = value.split(', ');

  const result = Object.keys(list)
    .filter(key => list[key]) // find right list via the key.
    .map(key =>
      list[key]
        .filter(option => tags.indexOf(option.value) !== -1)
        .map(({ label }) => label)
    ) // select and return the data we need.
    .filter(list => list.length > 0); // remove empty arrays from the list.

  return result && result.length > 0 ? result.join(', ') : value;
};

/**
 * This is the MapTags component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
const MapTags = ({ value, list }) => {
  const result = renderValue(value, list);

  return <span>{result}</span>;
};

/**
 * Declare expected property types.
 *
 * @type {Object}
 */
MapTags.propTypes = {
  value: string.isRequired,
  list: oneOfType([object, array]).isRequired,
};

export default MapTags;
